import { REDUCER_NAMESPACE } from './name';
export const SET_EXTENSION = `${REDUCER_NAMESPACE}/SET_EXTENSION`;
export const CLEAR_EXTENSION = `${REDUCER_NAMESPACE}/CLEAR_EXTENSION`;
export const SET_ALL_EXTENSIONS_LIST = `${REDUCER_NAMESPACE}/SET_ALL_EXTENSIONS_LIST`;
